import Joi from 'joi';
import categorySliderWithnavSlideSchema from '@utils/validate/blocksSchemes/categorySliderWithNavSlideSchema';
import blockAppearanceSchema from '@utils/validate/blocksSchemes/blockAppearanceSchema';
const categorySliderWithNavSchema = Joi.object({
  type: Joi.string().valid('categorySliderWithNav').required(),
  code: Joi.string().allow('', null).required(),
  promoText: Joi.string().allow('', null).required(),
  variant: Joi.string().required(),
  promoTextColor: Joi.string().allow('', null).required(),
  slides: Joi.array().min(1).items(categorySliderWithnavSlideSchema),
  ...blockAppearanceSchema
}).unknown(true);
export default categorySliderWithNavSchema;